let en = {
  Title: 'Product',
  Subtitle: 'Blockchain applications in several scenes ..',
  Content: [
    {name: 'Data Collaboration', desc: 'Solving  distributed data sources requires centralized data service caused security problem.'},
    {name: 'Supply-Chain Finance', desc: 'Open up all aspects of trade, improve the efficiency of trust transmission, and promote the construction of trade finance.'},
    {name: 'Data Attestation', desc: 'Solve data reliability and security issues, enhance the effectiveness of legal evidence.'},
    {name: 'Marketing', desc: 'Powerful marketing tools that support a variety of marketing activities without barriers of using blockchains, such as airdrops, red envelopes and so on.'},
  ],
}

let zh = {
  Title: 'Product',
  Subtitle: '多场景区块链应用。',
  Content: [
    {name: '数据协作', desc: '解决分散的数据源需要中心化的数据交换带来的安全隐患。'},
    {name: '供应链金融', desc: '多方聚合，打通贸易各个环节，提高信任传递效率，促进贸易金融生态建设。'},
    {name: '数据存证', desc: '解决数据容易被篡改，增强法律举证效力，可多方维护共有数据。'},
    {name: '推广营销', desc: '强大的营销活动合约工具，支持无技术门槛的区块链/金融空投、红包等各类营销活动的链上执行。'},
  ],
}

let name = 'Product'

export default {
  name,
  en,
  zh
}